<template>
  <div class="flex-column vld-parent" style="min-height: 100px;">
    <loading :active="isLoading" :color="'#ff0090'" :loader="'bars'" :is-full-page="false"></loading>
    <div class="h4">Sales Tax Summary</div>
    <div class="d-flex w-100 mb-5 mt-3">
      <ReportFilter
        :businessId="businessId"
        :showDateRange="true"
        :dateRangeLabel="'Tax Period'"
        :dateShortcut="'ytd'"
        :showLocations="true"
        :showPlanGroups="false"
        :showPlans="false"
        @applyFilter="applyFilter"
      ></ReportFilter>
    </div>
    <div class="flex-column w-100">
      <div class="d-flex justify-content-between mt-4 mb-2">
        <div class="h6 text-secondary my-auto">Details</div>
        <div class="d-flex">
          <ExportButton
            class="my-auto"
            :filename="`PredictileTax.csv`"
            :requestPayload="requestPayload"
            :url="`/businesses/${businessId}/reports/tax/export`"
            @onError="didErrorExport"
            label="csv"
            type="flat"
          ></ExportButton>
          <button type="button" class="btn btn-link my-auto pr-0" @click="loadData"><fa icon="sync" fixed-width /></button>
        </div>
      </div>
      <Table :enablePaging="true" :columns="columns" :page="page" @next="next" @previous="previous" @rows="updateRows"></Table>
    </div>
  </div>
</template>

<script>
import ReportFilter from "@/views/business/reports/components/ReportFilter.vue";
import ExportButton from "@/components/ExportButton.vue";
import Table from "@/components/Table.vue";
import moment from "moment";

const columns = [
  {
    type: "property",
    property: "businessLocationName",
    name: "Location",
  },
  {
    type: "property",
    property: "taxRateName",
    name: "Tax Rate",
  },
  {
    type: "property",
    property: "jurisdiction",
    name: "Jurisdiction",
  },
  {
    type: "property",
    property: "formattedPercentage",
    name: "Rate",
  },
  {
    type: "money",
    currency: "currency",
    property: "taxableRevenueInCents",
    name: "Taxable Revenue",
  },
  {
    type: "money",
    currency: "currency",
    property: "taxCollectedInCents",
    name: "Tax Collected",
  },
];

export default {
  name: "BusinessTaxReport",
  props: {
    businessId: String,
  },
  components: { Table, ReportFilter, ExportButton },
  data() {
    return {
      isLoading: false,
      columns: columns,
      page: {},
      skip: 0,
      take: 20,
      query: null,

      //filters
      startDateLocal: null,
      endDateLocal: null,
      selectedLocations: null,
      selectedPlanGroups: null,
      selectedBusinessPlans: null,
    };
  },
  computed: {
    computedStartDateLocal() {
      return this.startDateLocal ? moment(this.startDateLocal) : null;
    },
    computedEndDateLocal() {
      return this.endDateLocal ? moment(this.endDateLocal) : null;
    },
    requestPayload: {
      get: function() {
        return {
          startDate: this.computedStartDateLocal ? this.formatDate(this.computedStartDateLocal.clone().utc()) : null,
          endDate: this.computedEndDateLocal ? this.formatDate(this.computedEndDateLocal.clone().utc()) : null,
          businessLocationIds: this.selectedLocations,
        };
      },
    },
  },
  watch: {
    skip() {
      this.loadData();
    },
    take() {
      this.loadData();
    },
    query() {
      this.loadData();
    },
  },
  mounted() {
    this.loadData();
  },
  methods: {
    updateRows(e) {
      this.take = e;
    },
    didErrorExport(err) {
      console.log(err);
    },
    next() {
      this.skip += this.take;
    },
    previous() {
      this.skip -= this.take;
    },
    loadData() {
      this.isLoading = true;
      let url = `/businesses/${this.businessId}/reports/tax/search`;
      url += `?skip=${this.skip}&take=${this.take}`;

      this.$axios
        .post(url, this.requestPayload)
        .then((res) => {
          this.isLoading = false;
          this.page = this.transformPage(res.data.page);
        })
        .catch((err) => {
          this.isLoading = false;
          this.EventBus.$emit("GLOBAL_ERROR", {
            title: "Report Failed",
            message: "Sorry, It looks like we had some trouble loading this report. You may want to try again.",
            error: err,
          });
        });
    },
    transformPage(page) {
      const formattedData = { skip: page.request.skip, take: page.request.take, total: page.total, items: [] };
      if (page.items) {
        page.items.forEach(function(item) {
          item.formattedPercentage = item.percentage + "%";

          formattedData.items.push(item);
        });
      }

      return formattedData;
    },
    displayDate(date) {
      return date.format("MMM DD, YYYY");
    },
    formatDate(date) {
      return date.format("YYYY-MM-DD HH:mm");
    },
    applyFilter(filter) {
      this.startDateLocal = filter.startDate;
      this.endDateLocal = filter.endDate;
      this.selectedLocations = filter.selectedLocations;

      this.loadData();
    },
  },
};
</script>
